module.exports = __webpack_public_path__ + "static/media/53.77d29c6f.jpg";